import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonInput from "../../../components/input/CommonInput";
import CommonButton from "../../../components/button/CommonButton";
import HomeHeader from "../../../components/header/HomeHeader";
import Card from "../../../components/card";
import {
  emailValidator,
  getErrorMessage,
  handleBlanckSpaceInput,
} from "../../../constants/globalFunction";
import { imagePath } from "../../../constants/imagePath";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";
import { FaEnvelope } from "react-icons/fa";
import "./ForgotPassword.css";
import { appApiHandler } from "../../../api/appApiHandler";
import { string } from "../../../constants/string";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const onChangeEmail = (text) => {
    setEmail(handleBlanckSpaceInput(text));
  };

  const validateValues = () => {
    let isValid = true;

    if (!email.trim()) {
      setEmailError("Please enter email");
      isValid = false;
    } else if (!emailValidator(email)) {
      setEmailError("Please enter a valid email");
      isValid = false;
    } else {
      setEmailError("");
    }

    return isValid;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateValues();

    if (isValid) {
      try {
        const reqData = {
          email: email.trim(),
        };

        setLoading(true);
        const response = await appApiHandler.sendOtp(reqData);
        setLoading(false);
        if (response?.status === 200) {
          showSuccessToast("We have emailed your password reset OTP.");
          navigate("/otp-verification", { state: { email: email.trim() } });
        } else if (response?.message) {
          showErrorToast(getErrorMessage(response?.message));
        } else {
          showErrorToast(string.error.failed_due_to_internal_error);
        }
      } catch (err) {
        showErrorToast(string.error.failed_due_to_internal_error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="forgot-password-page" style={{ backgroundImage: `url(${imagePath.background})` }}>
      <HomeHeader />
      <div className="forgot-password-content">
        <div className="forgot-password-card">
          <img
            src={imagePath.appLogo}
            alt="Codeinfoway"
            className="forgot-password-logo"
          />

          <h1 className="forgot-password-title">Forgot password</h1>
          <p className="forgot-password-subtext">
            Enter your email address and we'll send you confirmation code to reset
            your password
          </p>

          <form onSubmit={onSubmit}>
            <CommonInput
              label="Email"
              value={email}
              onChange={onChangeEmail}
              placeholder="Enter email"
              error={emailError}
              type="email"
              leftIcon={<FaEnvelope className="forgot-password-icon" />}
            />

            <div className="button-row">
              <CommonButton
                title="Back"
                onPress={handleBack}
                outlined={true}
              />
              <CommonButton
                title={loading ? "Sending..." : "Submit"}
                type="submit"
                disabled={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
